import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import UserHandler from "js/utilities/user-handler";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar"

export default React.createClass({
  displayName: "matching-guide",
  scrollToGuide : null,
  scrollingEl: null,
  getInitialState: function() {
    var data  = [{name: "Matching Guide"}
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      navMenuParent: null,
      navMenu: null,
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section id="FaceTec Server 7.2">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2>FaceTec User Experience Best Practices</h2>
                  <p></p>
                </div>
                <p></p>
              </section>
              <hr />
              <SDKSidebar menuType="main" title="FaceTec User Experience Best Practices"/>
            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/user-experience-best-practices.jsx